module.exports = __webpack_public_path__ + "static/fowl-flow-icon-dd9d03ffefe058b927ae475fe7785141.png";